import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import eslang from '../../../lang/es.json';
import enlang from '../../../lang/en.json';
import Intro from '../intro/Intro';
import { Reference } from '../reference/Reference';
import IntroMobile from '../intro/IntroMobile';
import SceneMobile from '../sceneXX/SceneMobile';
import SceneDesktop from '../sceneXX/SceneDesktop';

const safeDocument = typeof document !== 'undefined' ? document : {};

// Querie
const lg = window.matchMedia('(min-width: 978px)');

const SceneController = () => {
  // Rezise Render
  // eslint-disable-next-line no-unused-vars
  const [windowSize, setWindowSize] = useState({
    heigth: window.innerHeight,
    width: window.innerWidth,
  });
  const setWindowDimensions = () => {
    lg.matches &&
      setWindowSize({ heigth: window.innerHeight, width: window.innerWidth });
  };

  // States
  const newCurrentScene = useSelector(
    (state) => state.sceneController.newCurrentScene
  );
  const lang = useSelector((state) => state.sceneController.lang);
  // Blockscroll & AllowScroll - Alternative
  const html = safeDocument.documentElement;
  const { body } = safeDocument;

  const blockScroll = () => {
    // eslint-disable-next-line func-names
    window.onscroll = function () {
      html.style.position = 'relative'; /* [1] */
      html.style.overflow = 'hidden'; /* [2] */
      body.style.position = 'relative'; /* [1] */
      body.style.overflow = 'hidden'; /* [2] */
    };
  };
  const allowScroll = () => {
    window.onscroll = null;
    html.style.position = '';
    html.style.overflow = '';
    body.style.position = '';
    body.style.overflow = '';
  };
  // Event Listener
  useEffect(() => {
    window.addEventListener('resize', setWindowDimensions);
    return () => {
      window.removeEventListener('resize', setWindowDimensions);
    };
  }, []);
  // State Scene Render Controller
  switch (newCurrentScene) {
    case '01':
      return lg.matches ? (
        <Intro
          id={0}
          data={lang == 'ESP' ? eslang?.intro : enlang?.intro}
          allowScroll={allowScroll}
          fs={
            lang == 'ESP'
              ? eslang?.intro?.titleFs
              : enlang?.intro?.titleFs || '15vw'
          }
        />
      ) : (
        <IntroMobile
          id={0}
          data={lang == 'ESP' ? eslang?.intro : enlang?.intro}
          allowScroll={allowScroll}
          fs={
            lang == 'ESP'
              ? eslang?.intro?.titleFs
              : enlang?.intro?.titleFs || '15vw'
          }
        />
      );
    case '02':
      return lg.matches ? (
        <SceneDesktop
          id={1}
          data={lang == 'ESP' ? eslang?.scene01 : enlang?.scene01}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene01?.titleFs
              : enlang?.scene01?.titleFs || '35vw'
          }
        />
      ) : (
        <SceneMobile
          id={1}
          data={lang == 'ESP' ? eslang?.scene01 : enlang?.scene01}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene01?.titleFs
              : enlang?.scene01?.titleFs || '35vw'
          }
        />
      );
    case '03':
      return lg.matches ? (
        <SceneDesktop
          id={1}
          data={lang == 'ESP' ? eslang?.scene02 : enlang?.scene02}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene02?.titleFs
              : enlang?.scene02?.titleFs || '35vw'
          }
        />
      ) : (
        <SceneMobile
          id={1}
          data={lang == 'ESP' ? eslang?.scene02 : enlang?.scene02}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene02?.titleFs
              : enlang?.scene02?.titleFs || '35vw'
          }
        />
      );
    case '04':
      return lg.matches ? (
        <SceneDesktop
          id={1}
          data={lang == 'ESP' ? eslang?.scene03 : enlang?.scene03}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene03?.titleFs
              : enlang?.scene03?.titleFs || '35vw'
          }
        />
      ) : (
        <SceneMobile
          id={1}
          data={lang == 'ESP' ? eslang?.scene03 : enlang?.scene03}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene03?.titleFs
              : enlang?.scene03?.titleFs || '35vw'
          }
        />
      );
    case '05':
      return lg.matches ? (
        <SceneDesktop
          id={1}
          data={lang == 'ESP' ? eslang?.scene04 : enlang?.scene04}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene04?.titleFs
              : enlang?.scene04?.titleFs || '35vw'
          }
        />
      ) : (
        <SceneMobile
          id={1}
          data={lang == 'ESP' ? eslang?.scene04 : enlang?.scene04}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene04?.titleFs
              : enlang?.scene04?.titleFs || '35vw'
          }
        />
      );
    case '06':
      return lg.matches ? (
        <SceneDesktop
          id={1}
          data={lang == 'ESP' ? eslang?.scene05 : enlang?.scene05}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene05?.titleFs
              : enlang?.scene05?.titleFs || '35vw'
          }
        />
      ) : (
        <SceneMobile
          id={1}
          data={lang == 'ESP' ? eslang?.scene05 : enlang?.scene05}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene05?.titleFs
              : enlang?.scene05?.titleFs || '35vw'
          }
        />
      );
    case '07':
      return lg.matches ? (
        <SceneDesktop
          id={1}
          data={lang == 'ESP' ? eslang?.scene06 : enlang?.scene06}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene06?.titleFs
              : enlang?.scene06?.titleFs || '35vw'
          }
        />
      ) : (
        <SceneMobile
          id={1}
          data={lang == 'ESP' ? eslang?.scene06 : enlang?.scene06}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene06?.titleFs
              : enlang?.scene06?.titleFs || '35vw'
          }
        />
      );
    case '08':
      return lg.matches ? (
        <SceneDesktop
          id={1}
          data={lang == 'ESP' ? eslang?.scene07 : enlang?.scene07}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene07?.titleFs
              : enlang?.scene07?.titleFs || '35vw'
          }
        />
      ) : (
        <SceneMobile
          id={1}
          data={lang == 'ESP' ? eslang?.scene07 : enlang?.scene07}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene07?.titleFs
              : enlang?.scene07?.titleFs || '35vw'
          }
        />
      );
    case '09':
      return lg.matches ? (
        <SceneDesktop
          id={1}
          data={lang == 'ESP' ? eslang?.scene08 : enlang?.scene08}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene08?.titleFs
              : enlang?.scene08?.titleFs || '35vw'
          }
        />
      ) : (
        <SceneMobile
          id={1}
          data={lang == 'ESP' ? eslang?.scene08 : enlang?.scene08}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene08?.titleFs
              : enlang?.scene08?.titleFs || '35vw'
          }
        />
      );
    case '10':
      return lg.matches ? (
        <SceneDesktop
          id={1}
          data={lang == 'ESP' ? eslang?.scene09 : enlang?.scene09}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene09?.titleFs
              : enlang?.scene09?.titleFs || '35vw'
          }
        />
      ) : (
        <SceneMobile
          id={1}
          data={lang == 'ESP' ? eslang?.scene09 : enlang?.scene09}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene09?.titleFs
              : enlang?.scene09?.titleFs || '35vw'
          }
        />
      );
    case '11':
      return lg.matches ? (
        <SceneDesktop
          id={1}
          data={lang == 'ESP' ? eslang?.scene10 : enlang?.scene10}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene10?.titleFs
              : enlang?.scene10?.titleFs || '35vw'
          }
        />
      ) : (
        <SceneMobile
          id={1}
          data={lang == 'ESP' ? eslang?.scene10 : enlang?.scene10}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene10?.titleFs
              : enlang?.scene10?.titleFs || '35vw'
          }
        />
      );
    case '12':
      return lg.matches ? (
        <SceneDesktop
          id={1}
          data={lang == 'ESP' ? eslang?.scene11 : enlang?.scene11}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene11?.titleFs
              : enlang?.scene11?.titleFs || '35vw'
          }
        />
      ) : (
        <SceneMobile
          id={1}
          data={lang == 'ESP' ? eslang?.scene11 : enlang?.scene11}
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          fs={
            lang == 'ESP'
              ? eslang?.scene11?.titleFs
              : enlang?.scene11?.titleFs || '35vw'
          }
        />
      );
    case '13':
      return (
        <Reference
          allowScroll={allowScroll}
          blockScroll={blockScroll}
          data={lang == 'ESP' ? eslang?.reference : enlang?.reference}
          logo={lang == 'ESP' ? eslang?.intro?.logo : enlang?.intro?.logo}
        />
      );
    default:
      return <>Cargando...</>;
  }
};

export default SceneController;
